module.exports = __webpack_public_path__ + "img/style-transfer.f071d9a1.webp";